// @flow

import { billing as BILLING_COUNTIRES } from 'Countries';
import { EnquireBaseFormModel } from 'shared_models/forms/EnquireBase';
import { messageFragment, companyFragment } from 'shared_models/forms/fragments/common';

/**
 * formModels
 *
 * Form models separated by form type keys fromm API
 */
export const formModels: Object = {
  corporateRequest: {
    ...EnquireBaseFormModel,
    fields: [...EnquireBaseFormModel.fields, companyFragment, messageFragment],
  },
  speakToCurator: {
    ...EnquireBaseFormModel,
    fields: [
      ...EnquireBaseFormModel.fields,
      {
        tag: 'select',
        name: 'countryCode',
        options: (intl: Object) =>
          BILLING_COUNTIRES.map((countryCode) => ({
            value: countryCode,
            text: intl.formatMessage({ id: `countries.${countryCode}` }),
          })),
        initialSelectedIndex: 0,
        label: 'forms.checkout.country',
      },
      {
        tag: 'input',
        type: 'text',
        name: 'budget',
        validateTrigger: 'onBlur',
        rules: [
          {
            pattern: '^[0-9]*$',
            message: 'forms.common.validation_messages.notValidBudget',
          },
        ],
        label: 'forms.emailEnquire.placeholder.budget',
        prefix: (props) =>
          props && props.customData && props.customData.currencySign
            ? props.customData.currencySign
            : null,
      },
      {
        tag: 'select',
        name: 'space',
        options: (intl) =>
          ['livingRoom', 'bedroom', 'kidsRoom', 'kitchen', 'other'].map((key) => {
            const text = intl.formatMessage({ id: `forms.emailEnquire.space.${key}` });

            // the value and the text in the option are the same in this field
            return { value: text, text };
          }),
        initialSelectedIndex: 0,
        label: 'forms.emailEnquire.placeholder.space',
      },
      messageFragment,
    ],
  },
  tradeEnquiry: {
    ...EnquireBaseFormModel,
    fields: [...EnquireBaseFormModel.fields, companyFragment, messageFragment],
  },
};
